/* eslint-disable import/no-named-as-default-member */

import { connect } from 'react-redux';
import App from './App';
import actions from '../redux/actions/buttonStateByCId';

const mapStateToProps = (state, ownProps) => ({
  buttonState: state.buttonStateByCId[ownProps.rexButton.cId],
});

const mapDispatchToProps = dispatch => ({
  updateButtonState: (state, cId) => dispatch(actions.updateButtonState(state, cId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/AppContainer.js